<h1 class="h5" *ngIf="company">{{ company.companySummary.businessName }}</h1>
<mat-card class="base-card p--0">
    <mat-card-content class="p--0">
    <div class="grid grid-cols-2 chart-market">
        <ngx-card [title]="'help.company_anagrafica_titolo' | translate" [icon]="'info_outline'" [bgcolor]="'white'"
            [contentClass]="'px--16 pt--0 fh'" [cardClass]="'icon-end p--8 mat-elevation-z0'">
            <app-overview-details [company]="company$()"></app-overview-details>
        </ngx-card>
        <div class="companylocation p--24">
            <app-leaflet-map [company]="company$()"/>
        </div>
    </div>
    </mat-card-content>
</mat-card>    
<div class="grid grid-cols-3 chart-market">
    <ngx-card [title]="'help.quota_di_mercato_titolo' | translate" [icon]="'timelapse'" [bgcolor]="'white'"
        [contentClass]="'px--0 pt--0 fh'" [cardClass]="'promo-bg-image icon-end p--8'">
        <ng-container *ngIf="quotaDiMercato; else noData">
            <div class="m--0 column fh">
                <div class=" m--0 row align-items-center">
                    <div class="chart-indicator p--16">
                      <ngx-indicator *ngIf="quotaDiMercato" [indicator]="quotaDiMercato"></ngx-indicator>
                    </div>
                </div>
               <div class="list-values row  gap-32">
                    <div class="list-item">
                        <div class="list-title text-primary" translate>Fatturato</div>
                        <div class="list-value">{{fatturatoAzienda | currencyFormatter}}</div>
                    </div>
                    <div class="list-item">
                        <div class="list-title text-primary" translate>Valore del mercato</div>
                        <div class="list-value">{{fatturatoDiSettore | currencyFormatter}}</div>
                    </div>
                </div>
            </div>
        </ng-container>
    </ngx-card>
    <ngx-card [title]="'EBITDA' | translate" [icon]="'euro'" [bgcolor]="'white'" [contentClass]="'px--0 pt--0 fh'"
        [cardClass]="'promo-bg-image icon-end p--8'">
        <ng-container *ngIf="ebitdaValueDiffPerc$(); else noData">
            <div class="m--0 column fh" >
                <div class=" m--0">
                    <div class="chart-indicator_ p--16">
                        <ng-container *ngIf="ebitdaChartMode == 'INDICATOR'; else chartEbitda">
                            <ngx-indicator  [indicator]="ebitdaValueDiffPerc$()" [trend]="ebitdaValueDiff$()"></ngx-indicator>
                        </ng-container>
                        <ng-template #chartEbitda> 
                            <plotly-plot #plotEbitda *ngIf="ebitdaChart" [data]="ebitdaChart.graphic.data" [layout]="ebitdaChart.graphic.layout" [config]="ebitdaChart.graphic.config"></plotly-plot>
                        </ng-template>
                    </div>
                </div>
                <div class="list-values row  gap-32">
                    <div class="list-item">
                        <div class="list-title text-primary" translate>Azienda</div>
                        <div class="list-value">{{ebitdaAzienda | currencyFormatter}}</div>
                    </div>
                    <div class="list-item">
                        <div class="list-title text-primary" translate>Media di settore</div>
                        <div class="list-value">{{ebitdaDiSettore | currencyFormatter}}</div>
                    </div>
                </div>
            </div>
        </ng-container>
    </ngx-card>
    <ngx-card [title]="'Innovation index' | translate" [icon]="'lightbulb_outline'" [bgcolor]="'white'"
        [cardClass]="'promo-bg-image icon-end p--8'" [contentClass]="'px--0 pt--0 fh'">
        <ng-container *ngIf="indiceDiInnovazione; else noData">
            <div class="m--0 column fh" >
                <div class=" m--0 row align-items-center">
                    <div class="chart-indicator p--16">
                        <ngx-indicator *ngIf="indiceDiInnovazione" [indicator]="indiceDiInnovazione"></ngx-indicator>
                    </div>
                </div>
                <div class="list-values row  gap-32">
                    <div class="list-item">
                        <div class="list-abstract text-muted" translate>innovation_index_abstract</div>
                    </div>
                </div>
            </div>
        </ng-container>
    </ngx-card>
</div>
<ng-template #noData>
   <div class="nodata mt--24 p--24">
       <span class="di di-warning di-4x"></span> <h5>Dato non disponibile</h5>
   </div>
</ng-template>